export const selectBucket = (state) => state.bucket;
